import { FindParams } from './find-params';

export interface FindZoneParams extends FindParams {
  charity_id?: string;
  partner_id?: string;
  charity_store?: string;
  partner_vehicle?: string;
  template_type?: string;
}
